export default __webpack_public_path__ + "b66b1623e2f198f42e1d6d9665f44e35.png";